import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { isBFFError } from '@/modules/common/helpers/bff';

import {
  Modal,
  Heading,
  SingleInput,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

import { verifyPassword } from '@/modules/trade/services/profit';

interface Props {
  isOpen: boolean;
}
interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {





const inputPassword = ref('');
const isCheckingPassword = ref(false);

const isDisabled = computed(() => {
  return Boolean(!inputPassword.value);
});

async function checkPassword() {
  try {
    isCheckingPassword.value = true;

    const isValidPassword = await verifyPassword(inputPassword.value);

    if (isValidPassword) emit('confirm');
  } catch (e) {
    let errorMessage = 'Houve um problema ao validar a senha.';

    if (isBFFError(e)) {
      errorMessage = e.error.message.formatted;
    }

    notify({
      group: 'wrn-notifications',
      text: errorMessage,
      type: NotificationTypes.error
    });
  } finally {
    isCheckingPassword.value = false;
  }
}

return { __sfc: true,emit, inputPassword, isCheckingPassword, isDisabled, checkPassword, Modal, Heading, SingleInput, ButtonContainer, ButtonPrimary, ButtonSecondary }
}

})